import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { AuthService } from './auth.service';
import { AppService, LoadingState } from './app.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Edgar Dev';
  private readonly _destroying$ = new Subject<void>();
  private readonly $app = inject(AppService);

  loadingState: LoadingState | null = null;
  loadingProgress = 0;
  isLoading = false;

  constructor(private appAuthService: AuthService) {}

  ngOnInit(): void {
    this.appAuthService.checkAndSetActiveAccount();
    this.$app.state$.pipe(takeUntil(this._destroying$)).subscribe((state) => {
      this.loadingState = state.loading || null;
      this.isLoading = !!state.loading && Object.values(state.loading).some(Boolean);
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }
}
